import { UNREGISTERED_USER } from './LayoutOverlay.constants'

export function getProductFruitsUserInfo(user) {
  return {
    id: user?.owner,
    role: user?.group || user?.role,
    username: user?.fullname || UNREGISTERED_USER,
  }
}
